<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">子商编列表</div>
        <div class="page-subtitle">查看商户的所有子商编信息</div>
      </div>
      <el-button type="primary" plain @click="goBack">返回</el-button>
    </div>
    <el-card>
      <el-table :data="subMerchants" stripe style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="type" label="类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'wechat'" type="success">微信</el-tag>
            <el-tag v-else-if="scope.row.type === 'alipay'" type="primary">支付宝</el-tag>
            <el-tag v-else type="info">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="merchantCode" label="商户编码" width="180" />
        <el-table-column prop="subMerchantId" label="子商编" width="180" />
        <el-table-column prop="originalRequestId" label="原请求流水号" width="180" />
        <el-table-column prop="authStatus" label="认证状态" width="180">
          <template slot-scope="scope">
            <!-- //0未确认，1已确认，2已销户 -->
            <el-tag v-if="scope.row.verifyStatus == '0'" type="info">未确认</el-tag>
            <el-tag v-else-if="scope.row.verifyStatus == '1'" type="success">已确认</el-tag>
            <el-tag v-else type="danger">已销户</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="userIdIdentity" label="第三方标识" width="200" />
        <el-table-column prop="mcc" label="MCC码" width="100" />
        <el-table-column prop="channelId" label="渠道商编码" width="160" />
        <el-table-column prop="channelFullName" label="渠道商全称" width="200" />
        <el-table-column prop="linkmanName" label="联系人" width="120" />
        <el-table-column prop="subMerchantIdType" label="子商编类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.subMerchantIdType === '0'">扫码</span>
            <span v-else-if="scope.row.subMerchantIdType === '1'">跳转</span>
            <span v-else>{{ scope.row.subMerchantIdType }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="merchantAttribute" label="商户属性" width="120" /> -->
        <el-table-column prop="created_at" label="创建时间" width="180" />
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetails(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="querySubMerchant(scope.row.id)">查询</el-button>
            <el-button type="text" size="small" @click="queryAuthStatus(scope.row.id)">查询认证状态</el-button>
            <el-button type="text" size="small" @click="testPayment(scope.row.id, scope.row.type)">测试支付</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 10"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px; text-align: right"
      />
    </el-card>
    
    <!-- 测试支付方式选择对话框 -->
    <el-dialog
      title="选择测试支付方式"
      :visible.sync="paymentDialogVisible"
      width="400px"
    >
      <el-radio-group v-model="selectedPaymentMethod">
        <div style="margin-bottom: 10px;" v-if="currentPayType === 'alipay'">
            <el-radio label="alipay_scan">扫码支付</el-radio>
           <el-radio label="alipay">H5/APP/小程序支付</el-radio>
        </div>
         <div style="margin-bottom: 10px;" v-else-if="currentPayType === 'wechat'"> 
            <el-radio label="wechat_scan">扫码支付</el-radio>
           <el-radio label="wechat">H5/APP/小程序支付</el-radio>
        </div>

      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmPaymentTest">确定</el-button>
      </span>
    </el-dialog>
    
    <!-- 二维码显示对话框 -->
    <el-dialog
      title="扫码支付"
      :visible.sync="qrcodeDialogVisible"
      width="400px"
    >
      <div style="text-align: center; padding: 20px 0;">
        <qrcode-vue v-if="qrcodeUrl" :value="qrcodeUrl" :size="200" level="H" />
        <div v-else>加载中...</div>
      </div>
      <div style="text-align: center; margin-top: 20px; color: #666;">
        请使用扫码支付
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrcodeDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      subMerchants: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      merchantId: '',
      // 测试支付相关
      paymentDialogVisible: false,
      selectedPaymentMethod: '',
      currentSubMerchantId: '',
      currentMerchantCode: '',
      currentUserIdIdentity: '',
      currentPayType: 'wechat',
      // 二维码相关
      qrcodeUrl: '',
      qrcodeDialogVisible: false
    };
  },
  computed: {},
  // 页面挂载完成
  mounted() {
    // 检查是否有id参数
    this.checkForMerchantId();
  },
  methods: {
    // 检查URL参数中的商户id
    checkForMerchantId() {
      const merchantId = this.$route.query.id;
      if (merchantId) {
        this.merchantId = merchantId;
        console.log('商户ID:', merchantId);
        // 加载子商户列表
        this.loadSubMerchantList();
      } else {
        this.$message.error('缺少商户ID参数');
      }
    },
    // 加载子商户列表
    loadSubMerchantList() {
      this.$http_get(`/admin/merchant/subMerchantList?mid=${this.merchantId}&page=${this.currentPage}&limit=${this.pageSize}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.subMerchants = res.data.data || [];
          this.total = res.data.total || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('加载子商户列表失败:', err);
      });
    },
    // 查看详情
    viewDetails(row) {
      // 根据类型跳转到不同的子商编申请页面并传入子商编id
      if (row.type === 'alipay') {
        this.$router.push(`/onboarding/submerchant-apply?id=${this.merchantId}&subMerchantId=${row.id}`);
      } else {
        this.$router.push(`/onboarding/wechat-submerchant-apply?id=${this.merchantId}&subMerchantId=${row.id}`);
      }
    },
    // 查询子商编
    querySubMerchant(subMerchantId) {
      console.log('查询子商编ID:', subMerchantId);
      this.$http_get(`/admin/merchant/wechatSubMerchantQuery?id=${subMerchantId}`, 1).then(res => {
        if (res && res.code === 200) {
          console.log('子商编查询结果:', res.data);
        } else {
          this.$message.error(res.msg || '查询失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('查询子商编失败:', err);
      });
    },
    // 查询认证状态
    queryAuthStatus(subMerchantId) {
      console.log('查询子商编认证状态ID:', subMerchantId);
      this.$http_get(`/admin/merchant/wechatSubMerchantAuthQuery?id=${subMerchantId}`, 1).then(res => {
        if (res && res.code === 200) {
          console.log('子商编认证状态查询结果:', res.data);
        } else {
          this.$message.error(res.msg || '查询认证状态失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('查询子商编认证状态失败:', err);
      });
    },
    // 测试支付
    testPayment(subMerchantId, payType) {
      console.log('测试支付参数:', { subMerchantId });
      // 获取当前子商户的支付类型
      this.currentPayType = payType || 'wechat';
      
      // 保存当前参数
      this.currentSubMerchantId = subMerchantId;
      
      // 默认选择微信扫码支付
      this.selectedPaymentMethod = 'wechat_scan';
      
      // 打开支付方式选择对话框
      this.paymentDialogVisible = true;
    },
   
    // 确认测试支付
    confirmPaymentTest() {
      if (!this.selectedPaymentMethod) {
        this.$message.warning('请选择支付方式');
        return;
      }
      
      this.$http_get(`/admin/merchant/testPayment?subMerchantId=${this.currentSubMerchantId}&paymentType=${this.selectedPaymentMethod}`, 1).then(res => {
        if (res && res.code === 200) {
          this.$message.success('测试支付请求成功');
          console.log('测试支付结果:', res.data);
          if (res.data.payUrl) {
            window.location.href = res.data.payUrl;
          } else {
            const codeUrl = res.data.codeUrl;
            if (codeUrl) {
              this.qrcodeUrl = codeUrl;
              this.qrcodeDialogVisible = true;
            } else {
              this.$message.error('支付URL不存在');
            }
          }
        } else {
          this.$message.error(res.msg || '测试支付失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('测试支付失败:', err);
      }).finally(() => {
        this.paymentDialogVisible = false;
      });
    },
    // 处理页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadSubMerchantList();
    },
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.loadSubMerchantList();
    },
    // 返回列表
    goBack() {
      this.$router.push('/onboarding');
    }
  }
};
</script>